import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useEffect, useState } from "react";

const AdminDashboard = () => {
  const [leads, setLeads] = useState([]);

  const fetchLeads = async () => {
    const snap = await getDocs(collection(db, "contacts"));
    setLeads(snap.docs.map(d => ({ id: d.id, ...d.data() })));
  };

  const deleteLead = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await deleteDoc(doc(db, "contacts", id));
    fetchLeads();
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  return (
    <>
      <h1 className="text-2xl font-bold mb-4">Leads</h1>

      <div className="overflow-x-auto">
        <table className="w-full border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2 border">Name</th>
              <th className="p-2 border">Email</th>
              <th className="p-2 border">Phone</th>
              <th className="p-2 border">Service</th>
              <th className="p-2 border">Action</th>
            </tr>
          </thead>
          <tbody>
            {leads.map(lead => (
              <tr key={lead.id}>
                <td className="p-2 border">{lead.name}</td>
                <td className="p-2 border">{lead.email}</td>
                <td className="p-2 border">{lead.phone}</td>
                <td className="p-2 border">{lead.service}</td>
                <td className="p-2 border">
                  <button
                    className="text-red-600"
                    onClick={() => deleteLead(lead.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {leads.length === 0 && (
              <tr>
                <td colSpan="5" className="text-center p-4">
                  No leads yet
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default AdminDashboard;
